import request from "../utils/request"

export function fetchActivityConfigs() {
  return request({
    url: "/admin/activity/config/campaigns",
    method: "get"
  })
}

export function fetchActivityConfig(id) {
  return request({
    url: `/admin/activity/config/campaigns/${id}`,
    method: "get"
  })
}

export function saveActivityConfig(data) {
  return request({
    url: "/admin/activity/config/campaigns",
    method: "post",
    data
  })
}

export function deleteActivityConfig(id) {
  return request({
    url: `/admin/activity/config/campaigns/${id}`,
    method: "delete"
  })
}

export function saveActivityPrize(data) {
  return request({
    url: "/admin/activity/config/prizes",
    method: "post",
    data
  })
}

export function moveActivityPrize(id, direction) {
  return request({
    url: `/admin/activity/config/prizes/${id}/move`,
    method: "post",
    params: { direction }
  })
}

export function deleteActivityPrize(id) {
  return request({
    url: `/admin/activity/config/prizes/${id}`,
    method: "delete"
  })
}
